import React, { useState, useEffect, useCallback } from 'react';
import {
    Text, View, Image, StyleSheet,
    ImageBackground
} from 'react-native';
import { debounce } from "lodash"
import { Avatar } from 'react-native-elements';

import AppTheme from '../../AppTheme';
import AppStyles from '../../AppStyles';
import { doPost } from '../../utils/services/api/API';
import { AppVersionCode } from '../../utils/constants/AppConstants';
import { store } from '../../store/store';
import { updateReduxEConsultInfo } from '../../utils/services/redux/commonRedux';
import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import { fbqEventName } from '../../utils/constants/fbqEventName';
import { SubscriptionAayuCardDesign } from '../../utils/widgets/AayuCard/AayuCardDesign';

import { PrimaryCTA } from '../../utils/widgets/CommonCTA';
import { handleModalBackpress, pwaGUID } from '../CommonService';
import { ServiceName } from '../../utils/constants/AppConstants';
import { ScreenRoute } from '../../utils/constants/ScreenRouteConstant';
import { backpressBheaviour$, CacheDataToRefresh, commonModalData$ } from '../../utils/services/subject-behaviour/CommonRxjsService';

import * as CommonUtils from '../../utils/services/CommonUtils';
import * as ScreenShimmer from '../shimmer-component/ScreenShimmer';
import * as AlertService from "../../utils/services/AlertLoaderService";
import ActionPopup from '../../utils/modals/ActionPopup';
import ModalContent from '../../utils/constants/ModalContentConstant';
import { getToastContent } from '../../utils/constants/ToastContentMapping';
import ToastModal from '../../utils/modals/ToastModal';
import { createEconsultPaymentWithSubscriptionData } from '../../utils/services/ReformatUtils';
import { checkCaseCodeLength, getCategoryImageNetworkURL } from '../../utils/services/econsult/EConsultUtils';
import RefreshCacheAction from '../../utils/services/webapp-services/RefreshCache';

const PaymentWithSubscription = (props) => {

    const [showAlert, setShowAlert] = useState(false)
    const [render, updateRenderState] = useState(false);
    const [eConsultData, updateEConsultData] = useState({
        memberName: '',
        memberId: 0,
        memberGender: '',
        serviceToken: '',
        subscriptionData: {
            userName: '',
            plan: '',
            maxConsultations: 25,
            consultCount: 0,
            consultLeft: 0,
            validFromDate: '',
            validTillDate: ''
        },
        walletBalance: 0,
        phoneNumber: '',
        caseCode: '',
        consultationId: 0,
        consultationHashcode: ''
    })
    const [toastData, setToastData] = useState({
        showToast: false, text: ''
    })

    function getServiceCharges(servicePrams) {
        updateRenderState(false);
        const params = {
            appVersionCode: AppVersionCode,
            couponCode: '',
            serviceName: ServiceName.consultation,
            appGUID: pwaGUID(),
            userId: servicePrams.memberId,
            consultationId: servicePrams.consultationId,
            eConsultParams: {
                consultationId: servicePrams.consultationId,
                userId: servicePrams.memberId
            }
        }; doPost('payment/get_service_charges', params).then(
            (response: any) => {
                const reduxState = store.getState();
                let eConsultData = createEconsultPaymentWithSubscriptionData(
                    reduxState.userDetails, reduxState.subscriptionData,
                    servicePrams, response.serviceTokenV2, response.walletBalance)
                updateEConsultData(eConsultData);
                setTimeout(() => { updateRenderState(true) }, 50)
            }, (error: any) => {
                getServiceCharges(props.route.params.serviceParams);
                setToastData({ showToast: true, text: getToastContent(error['msg']) })
            }
        )
    }

    function updateFBQData(eventType) {
        const eventName = fbqEventName[eventType]['remote'];
        const eventParams = {
            caseCode: eConsultData.caseCode,
            toPay: 0,
            walletBalance: eConsultData.walletBalance,
            plan_id: null
        }
        CommonUtils.triggerFBQ(eventName, eventParams);
    }

    function updateEConsultInfo() {
        updateReduxEConsultInfo({
            memberName: eConsultData.memberName,
            caseCode: eConsultData.caseCode,
            consultationId: eConsultData.consultationId,
            consultationHashcode: eConsultData.consultationHashcode,
            phoneNumber: eConsultData.phoneNumber,
            aayuPlanID: eConsultData.subscriptionData.plan,
            toPay: 0,
            walletBalance: eConsultData.walletBalance,
        })
    }

    function completeEConsultPayment(params) {
        AlertService.loaderModal.setLoader(true);
        // updateRenderState(true);
        doPost('payment/complete_consultation_payment', params).then(
            (response: any) => {
                updateFBQData('completion');
                AlertService.loaderModal.setLoader(false);
                let refreshList = [{ name: RefreshCacheAction.refreshUserProfileData, requestData: {skipMeoUpdate: true}}]
                CacheDataToRefresh.setRefreshList(refreshList)
                props.navigation.navigate(ScreenRoute.econsult_success);
            }, (error: any) => {
                updateRenderState(false);
                setToastData({ showToast: true, text: getToastContent(error['msg']) })
            }
        )
    }

    const checkConsultLeftString = () => {
        if (eConsultData.subscriptionData.consultLeft > 1)
            return 'Consultations';
        else return 'Consulttation';
    }

    const checkConsultLeftImage = () => {
        if (eConsultData.subscriptionData.consultLeft > 2)
            return '/images/aayuCard/aayu_subs_remaining_green.svg'
        else return '/images/aayuCard/aayu_subs_remaining_yellow.svg'
    }

    const exitFlowAction = () => {
        props?.navigation?.popToTop()
        props?.navigation.navigate(ScreenRoute.tab_controller_screen);
        setExitFlowPopup({ active: false })
    }

    const [showExitFlowPopup, setShowExitPopup] = useState(false)

    const setExitFlowPopup = (modalData) => {
        handleModalBackpress(modalData, {
            showModal: showExitFlowPopup,
            setModal: setShowExitPopup,
            modalDataSubscriber: modalDataSubscriber
        })
    }

    const modalDataSubscriber = useCallback(debounce((modalData) =>
        commonModalData$.next({ active: modalData.active }), 200), [])

    useEffect(() => {
        getServiceCharges(props.route.params.serviceParams);
        backpressBheaviour$.subscribe((backpressData) => {
            if (backpressData.backpressData['acsPaymentExitFlow'])
                setExitFlowPopup({ active: true })
        })
    }, []);

    return (
        <View>
            <CommonHeader navigation={props.navigation}
                confirmBackpress={true}
                alertOkColor={'#a32845'}
                alertCancelColor={AppTheme.color.primary}
                showWarning={true}
                alertTitle={'This case will be saved. You can come back later to submit this case.'}
                alertCancelText={'CANCEL'}
                alertOkText={'OK'}
                specificScreenOnBackpress={ScreenRoute.tab_controller_screen}
                title='Payment Details'></CommonHeader>

            {render ? <View style={{ marginTop: AppTheme.headerHeight }}>
                <View style={[styles.container, { backgroundColor: '#fafafa', flex: 1, paddingBottom: 20 }]} >

                    <View style={[AppStyles.flexRowCenter, { justifyContent: "space-between", marginVertical: 8, marginHorizontal: 16, marginBottom: 16 }]}>
                        <View>
                            <Text style={{ fontSize: 16, marginBottom: 4 }}>{eConsultData.memberName}</Text>
                            <Text style={AppStyles.text16xb}>E-Consult for <Text style={{ color: AppTheme.color.green.primary }}>
                                {checkCaseCodeLength(props.route.params.serviceParams.category)}</Text></Text>
                        </View>
                        <Avatar source={{ uri: getCategoryImageNetworkURL(props.route.params.serviceParams.caseCode) }}
                            size={60} avatarStyle={{ borderRadius: 150, margin: 6, shadowRadius: 4, shadowOpacity: 0.3 }} />
                    </View>

                    <View>
                        <View style={[AppStyles.flexRowCenter, {
                            backgroundColor: AppTheme.color.green.primary, alignContent: "center",
                            paddingTop: 20, paddingBottom: 70, paddingHorizontal: 24
                        }]}>
                            <Image source={{ uri: CommonUtils.getImagePath('/images/aayuCard/aayu_subs_sheild.svg'), width: 30, height: 30 }}
                                style={{ shadowRadius: 6, shadowOpacity: 0.6, marginRight: 8 }} />
                            <Text style={{ fontSize: 16, color: AppTheme.color.black }}>Your Aayu card subscription is <Text
                                style={AppStyles.text14xb}>ACTIVE</Text></Text>
                        </View>

                        <View style={{
                            position: 'absolute', top: 65,
                            marginHorizontal: 30,
                            width: AppTheme.appWidth - 60,
                            height: (AppTheme.appWidth - 60) * 0.45
                        }}>
                            <SubscriptionAayuCardDesign
                                subscriptionData={eConsultData.subscriptionData} />

                            <View style={[AppStyles.flexRowSpaceBetween,
                            { marginTop: 16 }]}>
                                <Text style={{ fontSize: 16, color: AppTheme.color.black }}>Your Remaining {checkConsultLeftString()}</Text>
                                <ImageBackground source={{
                                    uri: CommonUtils.getImagePath(checkConsultLeftImage()),
                                    width: 60, height: 60
                                }} style={{ marginRight: 8, paddingHorizontal: 15, paddingVertical: 15 }}>
                                    <View style={{ alignItems: "center", justifyContent: "center", width: 30, height: 30 }}>
                                        <Text style={styles.consultCount}><b>{eConsultData.subscriptionData.consultLeft}</b></Text></View>
                                </ImageBackground>
                            </View>
                        </View>



                    </View>
                </View>

                <View style={[AppStyles.submitBtn, { bottom: 20, width: AppTheme.appWidth, position: 'fixed' }]}>
                    <PrimaryCTA
                        type={'fill'}
                        text={`SUBMIT CASE`}
                        disabled={false}
                        marginVertial={24}
                        onPress={() => {
                            updateFBQData('initialize');
                            updateEConsultInfo();
                            completeEConsultPayment({
                                userId: eConsultData.memberId,
                                serviceTokenV2: eConsultData.serviceToken
                            });
                        }} />
                </View>
            </View> : <View style={{ marginTop: AppTheme.headerHeight }}>
                <ScreenShimmer.PayWithSubShimmer /></View>}

            <ActionPopup showPopUp={showExitFlowPopup}
                modalData={ModalContent.ServicePaymentSubscriptionBackpress}
                setPopUpOnCancel={() => setExitFlowPopup({ active: false })}
                setPopUpOnOk={() => exitFlowAction()} />

            <ToastModal showToast={toastData['showToast']}
                setToast={(toastData: any) => { setToastData(toastData) }}
                text={toastData['text']} />

        </View>
    )
}

{/* <View>
    <PayWithSubShimmer></PayWithSubShimmer>
</View> */}

const styles = StyleSheet.create(CommonUtils.addFontFamilylato({
    container: {
        flex: 1,
    },
    cardContainer: {
        margin: 16, padding: 16, backgroundColor: AppTheme.color.white, borderRadius: 8, shadowColor: AppTheme.color.black,
        zIndex: 1, shadowOpacity: 0.3, shadowRadius: 5, shadowOffset: {
            height: 1,
            width: 1
        }
    },
    greentext: {
        color: '#095911', fontSize: 15, textAlign: 'center', lineHeight: 24,
    },
    text: {
        textAlign: 'center',
        marginTop: 20,
        fontSize: 20,
    },
    Btn: {
        borderRadius: 10
    },
    consultCount: {
        fontSize: 20, textAlign: 'center',
        color: AppTheme.color.black
    },

    submit: {
        marginBottom: 10, marginHorizontal: 16, paddingTop: 10, paddingBottom: 10, marginTop: 20,
        backgroundColor: AppTheme.color.blue.cta, borderRadius: 7, borderWidth: 1, borderColor: '#fff'
    },
    submitText: {
        color: '#fff',
        textAlign: 'center',
    },
    textBottom: {
        fontSize: 14,
        lineHeight: 28
    },
    familyLabel: {
        fontSize: 18, lineHeight: 24, textAlign: "left"
    },
    familyCovered: {
        fontSize: 13, lineHeight: 10, textAlign: "left", letterSpacing: 1.5
    },
    validDate: {
        fontSize: 8, textAlign: "right", lineHeight: 10
    },
    dateValid: {
        fontSize: 12, lineHeight: 16, textAlign: "right"
    },
}))

export default PaymentWithSubscription;
